import { useTranslation } from 'react-i18next'
import sendButton from '../../../assets/images/buttons/send-button.svg'
import { Icon } from '../../atoms'
import { InputWrapper } from '..'
import * as style from './index.css'

export const SendMessageInput = (props: {
  message: string
  disabled?: boolean
  onSendMessage: () => void
  onUpdateMessage: (message: string | undefined) => void
}) => {
  const { t } = useTranslation()
  const handleSendMessage = (
    event:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
    props.onSendMessage()
  }

  return (
    <form
      className={style.messageInputContainer}
      onSubmit={handleSendMessage}
    >
      <InputWrapper
        value={props.message}
        disabled={props.disabled}
        placeholder={t('modal.chat.messageInput.placeholder')}
        maxLength={140}
        className={style.messageInputWrapper}
        classNameWrapped={style.messageInputWrapped}
        onChange={(value) => props.onUpdateMessage(value)}
      >
        <Icon
          src={sendButton}
          disabled={props.disabled || props.message.length === 0}
          type='submit'
          alt={t('modal.chat.messageInput.alt.sendMessage')}
          className={style.sendButton}
          analytic={{
            name: 'send_chat_message',
          }}
          onClick={handleSendMessage}
        />
      </InputWrapper>
    </form>
  )
}
